import { useSidebar } from "../../context/SidebarContext";

const Footer = () => {
    const { collapsed } = useSidebar();
    const sidebarWidth = collapsed ? "6.5rem" : "10rem";

    return (
        <footer 
            className="py-3 bg-body"
            style={{
                marginLeft: sidebarWidth,
                transition: "margin-left 0.3s ease",
            }}
        >
            <div 
                className="text-center"
                style={{
                    marginRight: sidebarWidth,
                    transition: "margin-right 0.3s ease",
                }}
            >
                <span>Copyright © Niralakka 2026</span>
            </div>
        </footer>
    );
};

export default Footer;